import React, { useState, useEffect } from 'react';
import { Phone, Mail, Facebook, Linkedin, Instagram, MessageCircle, Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
      // Update active section based on scroll position
      const sections = ['home', 'about', 'services', 'testimonials', 'uploads', 'contact'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <a href="tel:+919929176618" className="contact-item">
                <Phone size={16} />
                <span>+91 9929176618</span>
              </a>
              <a href="mailto:Blspaintsjaipur@gmail.com" className="contact-item">
                <Mail size={16} />
                <span>Blspaintsjaipur@gmail.com</span>
              </a>
            </div>
            <div className="social-whatsapp">
              <a 
                href="https://wa.me/919929176618" 
                target="_blank" 
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                <MessageCircle size={18} />
                <span>WhatsApp</span>
              </a>
              <div className="social-icons">
                <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <Facebook size={18} />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <Linkedin size={18} />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <Instagram size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="nav-content">
            <div className="logo" onClick={() => scrollToSection('home')}>
              BLS PAINTS
            </div>

            {/* Desktop Menu */}
            <ul className="nav-menu desktop-menu">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
                >
                  HOME
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
                >
                  ABOUT
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className={`nav-link ${activeSection === 'services' ? 'active' : ''}`}
                >
                  SERVICES
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className={`nav-link ${activeSection === 'testimonials' ? 'active' : ''}`}
                >
                  TESTIMONIALS
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('uploads')}
                  className={`nav-link ${activeSection === 'uploads' ? 'active' : ''}`}
                >
                  NEW UPLOADS
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
                >
                  CONTACT
                </button>
              </li>
            </ul>

            {/* Mobile Menu Toggle */}
            <button className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="mobile-menu">
              <button onClick={() => scrollToSection('home')} className="nav-link">HOME</button>
              <button onClick={() => scrollToSection('about')} className="nav-link">ABOUT</button>
              <button onClick={() => scrollToSection('services')} className="nav-link">SERVICES</button>
              <button onClick={() => scrollToSection('testimonials')} className="nav-link">TESTIMONIALS</button>
              <button onClick={() => scrollToSection('uploads')} className="nav-link">NEW UPLOADS</button>
              <button onClick={() => scrollToSection('contact')} className="nav-link">CONTACT</button>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Header;